import {Carousel} from '@bitstillery/common/components/portal'
import type {CarouselSlide} from '@bitstillery/common/components/portal'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

interface CarouselGiveAwayAttrs {
    controls?: boolean
    current?: number
    indicators?: boolean
    onchange?: (index: number) => void
    slides: CarouselSlide[]
}

export class CarouselGiveAway extends MithrilComponent<CarouselGiveAwayAttrs> {
    carousel_item(slide: CarouselSlide, active: boolean) {
        return (
            <div className={classes('item', {active})}>
                <div className='slide-header'>
                    <div className='title'>
                        {slide.link && (
                            <a href={slide.link} target='_blank'>
                                {slide.title}
                            </a>
                        )}
                        {!slide.link && <span>{slide.title}</span>}
                    </div>
                    <div className='subtitle'>{slide.description}</div>
                </div>
                <img src={slide.url} />
            </div>
        )
    }

    view(vnode: m.Vnode<CarouselGiveAwayAttrs>) {
        return (
            <Carousel
                className='c-carousel-giveaway'
                current={vnode.attrs.current ?? 0}
                item={this.carousel_item.bind(this)}
                mode='default'
                onchange={vnode.attrs.onchange ?? (() => {})}
                slides={vnode.attrs.slides}
                type='inline'
            />
        )
    }
}
